import { render, staticRenderFns } from "./PublicDialog.vue?vue&type=template&id=5caa191a&scoped=true&"
import script from "./PublicDialog.vue?vue&type=script&lang=js&"
export * from "./PublicDialog.vue?vue&type=script&lang=js&"
import style0 from "./PublicDialog.vue?vue&type=style&index=0&id=5caa191a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5caa191a",
  null
  
)

export default component.exports